export enum DocumentKind {
  MAIN = 'main',
  RENDITION = 'rendition',
}
